export function getShortFormeJuridique(forme: string): string {
  if (!forme) return '';

  const mapping: Record<string, string> = {
    'Société à responsabilité limitée': 'SRL',
    'Société anonyme': 'SA',
    'Société privée à responsabilité limitée': 'SPRL',
    'Association sans but lucratif': 'ASBL',
    'Coopérative à responsabilité limitée': 'SCRL',
    'Entreprise individuelle': 'EI',
    'Société en commandite simple': 'SCS',
    'Société en nom collectif': 'SNC',
  };

  return mapping[forme] || forme.slice(0, 3).toUpperCase();
}
